var ToastQueue = /*#__PURE__*/function () {
  function ToastQueue(opts) {
    this.id = -1;
    this.activeIds = [];
    this.pendingIds = [];
    this.subscriptions = {};
    this.toasts = {};
    this.opts = Object.assign({
      maxSize: 3,
      duration: 5000
    }, opts);
  }

  var _proto = ToastQueue.prototype;

  _proto.subscribe = function subscribe(fn) {
    this.id += 1;
    var subscriptionId = this.id;
    this.subscriptions[subscriptionId] = fn;
    return this.unsubscribe.bind(this, subscriptionId);
  };

  _proto.unsubscribe = function unsubscribe(subscriptionId) {
    delete this.subscriptions[subscriptionId];
  };

  _proto.getState = function getState() {
    var _this = this;

    return this.activeIds.map(function (id) {
      return _this.toasts[id];
    });
  };

  _proto.notify = function notify() {
    var _this2 = this;

    Object.keys(this.subscriptions).forEach(function (subscriptionId) {
      return _this2.subscriptions[subscriptionId]();
    });
  };

  _proto.refresh = function refresh() {
    var refreshed = false;

    while (this.activeIds.length < (this.opts.maxSize || Infinity) && this.pendingIds.length) {
      var toastId = this.pendingIds.shift();
      this.resume(toastId);
      this.activeIds.push(toastId);
      refreshed = true;
    }

    if (refreshed) {
      this.notify();
    }

    return refreshed;
  };

  _proto.enqueue = function enqueue(value, opts) {
    this.id += 1;
    var toastId = this.id;
    var toast = {
      toastId: toastId,
      dismiss: this.dismiss.bind(this, toastId),
      pause: this.pause.bind(this, toastId),
      resume: this.resume.bind(this, toastId)
    };
    var toastValue = value;

    if (typeof value === 'function') {
      toastValue = value(toast);
    }

    toast.value = toastValue;
    var toastOptions = opts;

    if (typeof opts === 'function') {
      toastOptions = opts(toastValue);
    }

    toast.opts = Object.assign({}, this.opts, toastOptions);
    this.toasts[toastId] = toast;
    this.pendingIds.push(toastId);
    this.refresh();
    return toast;
  };

  _proto.dismiss = function dismiss(toastId) {
    var activeRemoved = false;
    var activeIndex = this.activeIds.indexOf(toastId);

    if (activeIndex >= 0) {
      this.activeIds.splice(activeIndex, 1);
      activeRemoved = true;
    }

    var pendingIndex = this.pendingIds.indexOf(toastId);

    if (pendingIndex >= 0) {
      this.pendingIds.splice(pendingIndex, 1);
    }

    delete this.toasts[toastId];

    if (!this.refresh() && activeRemoved) {
      this.notify();
    }
  };

  _proto.dismissAll = function dismissAll() {
    if (this.activeIds.length) {
      this.activeIds = [];
      this.pendingIds = [];
      this.toasts = {};
      this.notify();
    }
  };

  _proto.pause = function pause(toastId) {
    var toast = this.toasts[toastId];

    if (!toast || !toast.timeout) {
      return;
    }

    clearTimeout(toast.timeout);
    delete toast.timeout;
    toast.ellapsed += Date.now() - toast.start;
  };

  _proto.pauseAll = function pauseAll() {
    var _this3 = this;

    this.paused = true;
    this.activeIds.forEach(function (toastId) {
      return _this3.toasts[toastId].pause();
    });
  };

  _proto.resume = function resume(toastId) {
    var toast = this.toasts[toastId];

    if (this.paused || !toast || toast.timeout) {
      return;
    }

    if (toast.opts.duration) {
      toast.ellapsed = toast.ellapsed || 0;
      toast.start = Date.now();
      toast.timeout = setTimeout(toast.dismiss, toast.opts.duration - toast.ellapsed);
    }
  };

  _proto.resumeAll = function resumeAll() {
    var _this4 = this;

    this.paused = false;
    this.activeIds.forEach(function (toastId) {
      return _this4.toasts[toastId].resume();
    });
  };

  return ToastQueue;
}();

export default ToastQueue;